import * as types from './action-types';

export const useDeliveryAddressForBilling = isUseDeliveryAddressForBilling => ({
  type: types.USE_DELIVERY_ADDRESS_FOR_BILLING,
  isUseDeliveryAddressForBilling,
});

/* Delivery */
export const setDeliveryAddressCountries = countries => ({type: types.DELIVERY_ADDRESS_SET_COUNTRIES, countries});

export const addDeliveryAddress = (addressId, values, selectedAddressCategory) => ({
  type: types.DELIVERY_ADDRESS_ADD, addressId, values, selectedAddressCategory,
});

export const updateDeliveryAddressField = (values, fieldName, value) => ({
  type: types.DELIVERY_ADDRESS_UPDATE_FIELD, ...values, name: fieldName, value,
});

export const resetDeliveryAddresses = deliveryCountry => ({
  type: types.RESET_DELIVERY_ADDRESSES, deliveryCountry,
});

export const updateEditedAddress = (addressId, values) => ({
  type: types.UPDATE_EDITED_ADDRESS, addressId, values,
});

export const resetEditedAddress = () => ({
  type: types.RESET_EDITED_ADDRESS,
});

export const updateDeliveryAddressFieldInOverlay = (values, fieldName, value) => ({
  type: types.DELIVERY_ADDRESS_UPDATE_FIELD_IN_OVERLAY, ...values, name: fieldName, value,
});

export const updateAddressContactNumber = (addressId, contactNumber) => ({
  type: types.ADDRESS_UPDATE_CONTACT_NUMBER, addressId, contactNumber,
});

export const updateDeliveryContactNumber = (value) => {
  let formattedValue = value;
  if (window?.start?.settings?.cleanse_contact_number_unicode_whitespace_and_nbsp) {
    formattedValue = formattedValue.replace(/\s+/g, ' ');
    formattedValue = formattedValue.replace(/&nbsp;/g, '');
    formattedValue = formattedValue.trim();
  }

  return {type: types.DELIVERY_ADDRESS_UPDATE_CONTACT_NUMBER, value: formattedValue};
};

export const selectDeliveryAddress = (addressId, selectedAddressCategory = 'UNKNOWN') => ({type: types.DELIVERY_ADDRESS_SELECT, addressId, selectedAddressCategory});

export const updateDeliveryAddress = (addressId, values) => ({
  type: types.DELIVERY_ADDRESS_UPDATE_FIELDS,
  addressId,
  values,
});

export const overwriteDeliveryAddress = (addressId, values, selectedAddressCategory = 'NEW_RESIDENTIAL_ADDRESS') => ({
  type: types.DELIVERY_ADDRESS_OVERWRITE,
  addressId,
  values,
  selectedAddressCategory,
});

export const showSpinner = show => ({
  type: types.SHOULD_SHOW_SPINNER,
  show,
});

export const setAddressEntryType = entryType => ({
  type: types.SET_ADDRESS_ENTRY_TYPE,
  entryType,
});

/* Billing */
export const setBillingAddressCountries = countries => ({type: types.BILLING_ADDRESS_SET_COUNTRIES, countries});

export const updateBillingAddress = values => ({type: types.BILLING_ADDRESS_UPDATE, payload: values});

export const overwriteBillingAddress = values => ({type: types.BILLING_ADDRESS_OVERWRITE, payload: values});

/* Postcode Anywhere */
export const postcodeAnywhereShowFields = (addressType, isShowFields) => ({
  type: types.POSTCODE_ANYWHERE_SHOW_FIELDS,
  addressType,
  isShowFields,
});

/* Address Lookup */
export const useAddressLookupResult = (addressType, values) => ({
  type: (addressType === 'delivery' ? types.ADDRESS_LOOKUP_USE_DELIVERY_RESULT : types.ADDRESS_LOOKUP_USE_BILLING_RESULT),
  values,
});

/*  */
export const useExpressCheckoutAddress = values => ({
  type: types.EXPRESS_CHECKOUT_RETURNED_ADDRESS,
  values,
});

/* Resident ID */
export const updateResidentID = residentID => ({
  type: types.UPDATE_RESIDENT_ID_PROPERTY,
  propName: 'newResidentID',
  value: residentID,
});

export const setUseStoredResidentID = shouldUseResidentID => ({
  type: types.UPDATE_RESIDENT_ID_PROPERTY,
  propName: 'useStoredID',
  value: shouldUseResidentID,
});
